




































































































































import Vue from 'vue'
import dayjs from 'dayjs'
import AddMenu from './components/AddMenu.vue'
import {menuProps} from '@/utils/commonDef'
import {
  DictServiceProxy,
  MasterlinkMenuServiceProxy,
  Menu,
  MenuVO,
  MasterlinkMenuTreeNode,
  ROfListOfMenuVO
} from '@/service-proxies/app-v2/system.service-proxies'
import {
  AppServiceProxy,
  IPageOfApp,
  App,
  MenuServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import ViewEdit from './components/ViewEdit.vue'
import MenuTable from './components/MenuTable.vue'
const mMenuService = new MasterlinkMenuServiceProxy()
const appService = new AppServiceProxy()
const menuService = new MenuServiceProxy()
const dictService = new DictServiceProxy()

export default Vue.extend({
  name: '', // host租户-菜单维护
  components: {
    AddMenu,
    ViewEdit,
    MenuTable
  },
  data() {
    return {
      data: [],
      selectedRowKeys: [],
      visible: false,
      modalLoading: false,
      menuTypeList: [],
      audienceList: [],
      //chooseMenuType: undefined, //pc
      appList: [],
      // chooseApp: undefined,
      audience: [], // 租户
      filter: '',
      detailshow: false,
      editdata: {},
      loading: false,
      menuKind: {}, // 菜单属性列表
      chooseMenuKind: "3", // 默认菜单属性
      scrollY: window.document.body.clientHeight - 200
    }
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys: [], selectedRows: []) => {
          this.selectedRowKeys = selectedRowKeys
        }
      }
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
  },
  created() {
    Promise.all([
      dictService.dictionary('menu_kind'),
      dictService.dictionary('client_type'),
      dictService.dictionary('audience_category')
    ]).then((res) => {
      // this.menuKind = res[0].data
      let menuKind = {}
      res[0].data.map(item => {
        menuKind[item.dictKey] = item.dictValue
      })
      this.menuKind = menuKind
      this.menuTypeList = res[1].data
      this.audienceList = res[2].data
      this.load()
    })
    appService.pageForCode(1, '', 9999).then((res: IPageOfApp) => {
      this.appList = res.records
    })
  },
  watch: {},
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    helper(arr: any[] | undefined): any[] {
      const res: any[] = []
      if (!arr || !arr.length) {
        return res
      }
      for (let item of arr) {
        if (item.audience) {
          item.audienceMsg = this.getAudience(item.audience)
        }
        const target = {
          ...item,
          // ...item.data,
          children: this.helper(item.children)
        }
        // delete target.data
        if (!target.children.length) {
          delete target.children
        }
        res.push(target)
      }
      return res
    },
    getAudience(data) {
      let arr = [];
      const v = data
      this.audienceList.forEach((k: any) => {
        const i = Number(k.dictKey)
        if((v & i) === i){
          arr.push(k.dictValue)
        }
      })
      if(arr.length>1){
        return arr.join(',')
      }else{
        return arr[0]
      }
    },
    addMenuBack(flag: Boolean) {
      this.visible = false
      flag && this.load()
    },
    changeKind(value){
      console.log('time1:', new Date().getTime())
      this.chooseMenuKind = menuProps.find(item => item.hasOwnProperty('checkedDynamic') && item.checkedDynamic === value.target.checked).value
      // this.chooseMenuKind = value.target.checked ? '2' : '3'
      // this.load() // 会导致勾选卡顿
    },
    load() {
      this.loading = true
      this.data = []
      console.log('time2:', new Date().getTime())
      // mMenuService
      //   .getMenus(this.chooseApp, this.chooseMenuType,this.chooseMenuKind,this.filter)
      //   .then(res => {
      //     this.loading = false
      //     let temp = res.data.menuTreeNodeList
      //     if (!temp) return
      //     this.data = helper(temp)
      //   })
      menuService.lazyList('',this.chooseMenuKind,this.filter,'').then(res=>{
        this.loading = false
        let temp = res.data
         if (!temp) return
         this.data = this.helper(temp)
      })
    },
    handleDelete() {
      this.detailshow = false
      if (!this.hasSelected) {
        this.$message.error('先勾选菜单再删除！')
        return
      }
      menuService.remove(this.selectedRowKeys.join()).then(() => {
        this.$message.info('删除成功')
        this.load()
      })
    },
    rowClick(menu: MenuVO) {
      return {
        on: {
          click: () => {
            this.detailshow = true
            this.editdata = menu
          }
        }
      }
    },
    handleEdit(menu: MenuVO) {
      if(this.detailshow) {
        this.$confirm({
            title: this.$t('switch_tips_title'),
            content: this.$t('switch_tips_content'),
            onOk: () => {
              this.detailshow = true
              this.editdata = menu
            },
            onCancel() {
              return
            },
          });
      }else {
        this.detailshow = true
        this.editdata = menu
      }
    },
    closedetail(flag: boolean) {
      this.detailshow = false
      if (flag) {
        this.load()
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
})
